import styled from 'styled-components';
import { StyleColor } from '../../../utils/styles-constants';

interface ItemContextualMenuProps {
	isRowView: boolean;
}

const ItemContextualMenu = styled('div')`
	position: absolute;
	${(props: ItemContextualMenuProps) => props.isRowView ?
		`bottom: 10px;
		right: 11px;
		z-index: 3;`
		:
		`bottom: 25px;
		right: 7px;`
	}

	width: 30px;
	height: 30px;
	cursor: pointer;

	> svg {
		width: 100%;
		height: 100%;

		> g > circle {
			fill: ${StyleColor.White};
		}
	}
`;

export {
	ItemContextualMenu,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/ActionButton/styles.ts